import { NavLink } from "react-router-dom";
import { LogOut } from "lucide-react";
import { ADMIN_NAV } from "@/config/navigation";
import { useI18n } from "@/i18n/I18nProvider";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/brand/Logo";
import { LanguageToggle } from "@/components/LanguageToggle";

export const AdminSidebar = ({ onNavigate, idPrefix = "nav" }) => {
  const { t } = useI18n();
  const { logout } = useAuth();
  return (
    <div className="flex h-full flex-col bg-[#000B45] text-white">
      <div className="px-5 pb-4 pt-5">
        <Logo size="md" testId={`${idPrefix}-logo`} className="-ml-1" />
        <p className="mt-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-[#FEB601]">{t("app.product")}</p>
      </div>
      <nav className="sidebar-scroll flex-1 overflow-y-auto px-3 pb-4">
        {ADMIN_NAV.map((g) => (
          <div key={g.group} className="mt-4">
            <p className="px-3 pb-1.5 text-[10px] font-bold uppercase tracking-[0.2em] text-white/40">{t(`nav.groups.${g.group}`)}</p>
            {g.items.map((m) => (
              <NavLink
                key={m.key}
                to={m.path}
                end={m.path === "/admin"}
                onClick={onNavigate}
                data-testid={`${idPrefix}-${m.key}-link`}
                className={({ isActive }) =>
                  `group flex min-h-[44px] items-center gap-3 rounded-lg border-l-4 px-3 text-sm font-medium transition-colors ${
                    isActive ? "border-[#FEB601] bg-white/10 text-white" : "border-transparent text-white/70 hover:bg-white/5 hover:text-white"
                  }`
                }
              >
                <m.icon className="h-[18px] w-[18px] shrink-0" />
                <span className="flex-1 truncate">{t(`nav.${m.key}`)}</span>
                {!m.ready && <span className="h-1.5 w-1.5 rounded-full bg-[#FEB601]/60" title={t("common.comingSoon")} />}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>
      <div className="flex items-center justify-between gap-2 border-t border-white/10 px-4 py-4">
        <LanguageToggle dark testIdPrefix={`${idPrefix}-lang`} />
        <button
          type="button"
          onClick={logout}
          data-testid={`${idPrefix}-logout-button`}
          className="flex min-h-[44px] items-center gap-2 rounded-lg px-3 text-sm font-semibold text-white/80 transition-colors hover:bg-white/10 hover:text-white"
        >
          <LogOut className="h-4 w-4" /> {t("common.logout")}
        </button>
      </div>
    </div>
  );
};
